module.exports = __webpack_public_path__ + "static/media/tink.2a6bb6f5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/tink.wav
// module id = 65
// module chunks = 0